<template>
  <ul class="apartment-search-count" role="list">
    <li
      v-for="(item, index) in apartmentCountData"
      :key="index"
      v-if="showApartmentType( Object.keys(apartmentCounts)[index] )"
    >
      {{ item.name }}: <strong>{{ item.count }}</strong>
    </li>
  </ul>
</template>

<script>

import utils from '../mixins/utils';


export default {
  name: 'ApartmentCountPerType',
  mixins: [utils.translate],
  props: {
    apartmentCountData: {
      type: Array,
      required: true
    },
    apartmentCounts: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedTypes: [],
    }
  },
  created() {
    // Get URL parameters string.
    const params = new URLSearchParams(window.location.search)

    // Get the value of the 'q' URL parameter.
    const q = params.get('q')

    if (q) {
      try {
        // Decode the URL-encoded string and parse it as JSON.
        const decoded = decodeURIComponent(q)
        const parsed = JSON.parse(decoded)

        // Extract the 'type' property from the parsed object.
        this.selectedTypes = parsed.type || []
      } catch (err) {
        console.warn('Failed to parse apartment type from query string:', err)
      }
    }
  },
  methods: {
    showApartmentType(item) {
      // Check if the item is in the selectedTypes array or if selectedTypes is empty.
      return this.selectedTypes.length === 0 || this.selectedTypes.includes(item)
    }
  }
}

</script>

<style lang="scss">
  @import "~styles/definitions";

  .apartment-search-count {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    gap: 1rem;
    margin-top: .5rem;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      gap: .5rem 1rem;
    }

    li {
      font-size: 0.75rem;
      text-transform: uppercase;
      line-height: 1rem;
      font-weight: normal;
    }
  }

</style>
